import React from 'react';
import { Settings } from 'lucide-react';

const UserProfile = ({
  userName,
  userEmail,
  hasSubscription,
  hasBasicSubscription,
  onUpgrade,
  handleSettingsClick,
  isMobile
}) => {
  return (
    <div className={`px-6 py-4 border-t border-[rgb(199,199,195)] dark:border-gray-900 ${isMobile ? 'mt-auto' : ''}`}>
      <div className="flex items-center">
        <div className="w-10 h-10 rounded-lg bg-purple-500 flex items-center justify-center text-white font-bold text-xl mr-3 flex-shrink-0">
          {userName.charAt(0).toUpperCase()}
        </div>
        <div className="flex-grow min-w-0">
          <h3 className="font-medium truncate">{userName}</h3>
          <p className="text-xs text-gray-600 dark:text-gray-400 truncate">{userEmail}</p>
        </div>
        <button 
          className="ml-2 p-1 rounded-full hover:bg-gray-300 dark:hover:bg-gray-700 flex-shrink-0" 
          onClick={handleSettingsClick}
          aria-label="Open settings"
        >
          <Settings size={20} />
        </button>
      </div>
      {!hasSubscription && !hasBasicSubscription && (
        <button
          onClick={onUpgrade}
          className="mt-4 w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-4 rounded"
        >
          See Pro and Max Plans
        </button>
      )}
    </div>
  );
};

export default UserProfile;
